<template>
  <div class="my-space-card my-space-card--scrollable" :class="{ 'my-space-card--mobile-collapsed': collapsed && !expanded, 'my-space-card--expanded': expanded }" :role="expanded ? 'dialog' : null" :aria-modal="expanded ? 'true' : null" tabindex="-1" @keydown.esc="expanded = false">
    <div v-if="expanded" class="my-space-card-modal-backdrop" aria-hidden="true" @click="expanded = false"></div>
    <div class="my-space-card-header">
      <span class="my-space-card-title"><span class="my-space-card-icon my-space-priority-assignee__header-icon"><AppIcon name="assignment_ind" /></span>Prioridades por responsable</span>
      <button type="button" class="my-space-card-refresh" :disabled="loading || refreshing" title="Actualizar tareas prioritarias" @click.stop="refresh"><AppIcon name="refresh" :class="{ 'my-space-card-refresh__icon--spinning': refreshing }" /></button>
      <button type="button" class="my-space-card-expand" :aria-expanded="String(expanded)" :title="expanded ? 'Cerrar' : 'Abrir vista ampliada'" @click.stop="expanded = !expanded"><AppIcon :name="expanded ? 'close' : 'open_in_full'" /></button>
      <button v-if="!expanded" type="button" class="my-space-card-collapse" :aria-expanded="String(!collapsed)" @click="collapsed = !collapsed"><AppIcon :name="collapsed ? 'expand_more' : 'expand_less'" /></button>
    </div>
    <div class="my-space-card-body">
      <div v-if="loading" class="my-space-card-loading"><b-spinner small /></div>
      <template v-else>
        <details v-for="group in groups" :key="group.id" class="my-space-task-tree my-space-priority-assignee__group" :class="{ 'my-space-priority-assignee__group--urgent': group.hasUrgent }">
          <summary class="my-space-task-tree__summary">
            <span class="my-space-task-tree__group">
              <b-avatar v-if="group.image" :src="group.image" size="24px" />
              <b-avatar v-else size="24px" :text="avatarFromName(group.name).text" :style="avatarFromName(group.name).style" />
              <span class="my-space-task-tree__group-copy"><span class="my-space-task-tree__group-name">{{ group.name }}</span><span class="my-space-priority-assignee__type">Asignado</span></span>
            </span>
            <span class="my-space-task-tree__meta"><b-badge class="my-space-task-tree__count">{{ group.tasks.length }}</b-badge><AppIcon name="expand_more" class="my-space-task-tree__chevron" /></span>
          </summary>
          <div class="my-space-task-tree__children">
            <div v-for="item in group.tasks" :key="item.id" class="my-space-task-tree__task my-space-priority-assignee__task">
              <AppIcon name="subdirectory_arrow_right" class="my-space-task-tree__task-icon" />
              <span class="my-space-priority-assignee__task-copy"><span class="my-space-day-item-text">{{ item.title }}</span><small>{{ relationLabel(item) }}</small></span><AppIcon v-if="item.reminder" name="notifications" class="my-space-priority-assignee__reminder" v-b-tooltip.hover :title="reminderLabel(item.reminder)" />
              <TaskChecklistProgress :progress="item.checklist_progress" :status="item.checklist_status" />
              <span class="my-space-priority-assignee__priority" :class="'my-space-priority-assignee__priority--' + item.priority">{{ priorityLabel(item.priority) }}</span>
              <router-link class="my-space-priority-assignee__go" :to="taskRoute(item)" :title="'Ver ' + item.title" :aria-label="'Ver detalle de ' + item.title"><AppIcon name="arrow_forward" /></router-link>
            </div>
          </div>
        </details>
        <EmptyState v-if="!groups.length" icon="priority_high" title="No hay tareas prioritarias" description="No tenés tareas pendientes de prioridad alta o urgente." />
      </template>
    </div>
  </div>
</template>

<script>
import serviceTasks from '../staff/services'
import ErrorToken from '@/handler/errorToken'
import Funciones from '@/handler/funciones'
import { EventBus } from '@/handler/event-bus'
import TaskChecklistProgress from './TaskChecklistProgress'
import moment from 'moment'

export default {
  name: 'MySpacePriorityTasksByAssigneeWidget',
  components: { TaskChecklistProgress },
  data: () => ({ loading: true, refreshing: false, collapsed: window.innerWidth <= 767, expanded: false, tasks: [] }),
  computed: {
    groups() {
      var groups = {}
      this.tasks.forEach((item) => {
        var assigned = item.assigned || {}
        var id = item.assigned_staff_id || 'unassigned'
        if (!groups[id]) groups[id] = { id, name: assigned.name || 'Sin asignar', image: assigned.image || '', hasUrgent: false, urgentCount: 0, highCount: 0, tasks: [] }
        groups[id].tasks.push(item)
        groups[id].hasUrgent = groups[id].hasUrgent || item.priority === 'urgent'
        if (item.priority === 'urgent') groups[id].urgentCount += 1
        if (item.priority === 'high') groups[id].highCount += 1
      })
      return Object.keys(groups).map(key => groups[key]).sort((first, second) => {
        if (second.urgentCount !== first.urgentCount) return second.urgentCount - first.urgentCount
        if (second.highCount !== first.highCount) return second.highCount - first.highCount
        return second.tasks.length - first.tasks.length
      })
    },
  },
  mounted() { EventBus.$on('MySpace:tasks-refresh', this.refresh); this.load() },
  beforeDestroy() { EventBus.$off('MySpace:tasks-refresh', this.refresh) },
  methods: {
    load(refresh = false) {
      if (refresh) this.refreshing = true
      serviceTasks.obtenerTareas({ status: 'pending', scope: 'related' }).then((response) => {
        var items = Array.isArray(response.data) ? response.data : []
        this.tasks = items.filter(item => item.assigned_staff_id && ['urgent', 'high'].includes(item.priority) && this.relationLabel(item))
        this.loading = false
        this.refreshing = false
      }).catch((error) => {
        this.loading = false
        this.refreshing = false
        this.$awn.alert(ErrorToken.valid(error))
      })
    },
    refresh() { if (!this.loading && !this.refreshing) this.load(true) },
    relationLabel(item) {
      if (item.customer_id) return 'Cliente · ' + ((item.customer && item.customer.name) || 'Sin nombre')
      if (item.supplier_id) return 'Proveedor · ' + ((item.supplier && item.supplier.name) || 'Sin nombre')
      if (item.project_id) return 'Proyecto · ' + ((item.project && item.project.name) || 'Sin nombre')
      return ''
    },
    relationType(item) {
      if (item.customer_id) return 'customer'
      if (item.supplier_id) return 'supplier'
      if (item.project_id) return 'project'
      return ''
    },
    relationId(item) {
      return item.customer_id || item.supplier_id || item.project_id || ''
    },
    taskRoute(item) {
      return { name: 'TasksStaffCrud', params: { taskId: item.id }, query: { widget_task_filter: String(Date.now()), relation_type: this.relationType(item), relation_id: this.relationId(item), assigned_staff_id: item.assigned_staff_id || '', priority: item.priority } }
    },
    avatarFromName(name) { return Funciones.avatarFromName(name || '') },
    priorityLabel(priority) { return priority === 'urgent' ? 'Urgente' : 'Alta' },
    reminderLabel(reminder) { return 'Recordatorio: ' + moment(reminder.remind_at).format('DD/MM/YYYY HH:mm') },
  },
}
</script>

<style scoped>
.my-space-priority-assignee__header-icon { background: var(--app-color-primary); }
.my-space-priority-assignee__type, .my-space-priority-assignee__task-copy small { color: var(--app-color-text-muted); font-size: var(--app-text-xs); }
.my-space-priority-assignee__task-copy { display: flex; flex: 1; flex-direction: column; min-width: 0; }
.my-space-priority-assignee__task-copy .my-space-day-item-text { color: var(--app-color-text); font-weight: var(--app-font-bold); }
.my-space-priority-assignee__group--urgent .my-space-task-tree__summary { background: var(--app-color-danger-soft) !important; }
.my-space-priority-assignee__priority { margin-left: 8px; color: var(--app-color-warning); font-size: var(--app-text-xs); font-weight: var(--app-font-bold); }
.my-space-priority-assignee__priority--urgent { color: var(--app-color-danger); }
.my-space-priority-assignee__go { display: inline-flex; align-items: center; justify-content: center; width: 26px; height: 26px; margin-left: 8px; padding: 0; border-radius: 50%; background: var(--app-color-primary-soft); color: var(--app-color-primary); }
.my-space-priority-assignee__go:hover { background: var(--app-color-primary); color: var(--app-color-on-primary); text-decoration: none; }
.my-space-priority-assignee__reminder { flex: 0 0 auto; color: var(--app-color-primary); font-size: 16px; }
</style>
